import React from 'react';

export const SavedSearchItem = (props) => {

        const { data } = props;
        if( data.length === 1 ) {
            return (
                <div className="details__value">
                    { data[0].name }
                </div>
            )
        }

        if (data.length > 1) {
            return (
                <div>
                    {
                        data.map( ( el, i ) => {
                            return (
                                <div key={ i } className="">
                                    { el.name }
                                </div>
                            )
                        } )
                    }
                </div>
            )
        }
}




// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/SavedSearchItem.js